import {useEffect, useState} from 'react';

const SCROLL_HIDE_DELAY_MS = 400;

/**
 * Tracks whether the given container is currently being scrolled. Flips back to false
 * after a short idle window so a temporarily-visible scrollbar fades away on its own.
 */
export const useAttachmentScrollIndicator = (containerEl: HTMLElement | null): boolean => {
  const [isScrolling, setIsScrolling] = useState(false);

  useEffect(() => {
    if (!containerEl) return;
    let hideTimer: number | undefined;

    const handleScroll = (): void => {
      setIsScrolling(true);
      window.clearTimeout(hideTimer);
      hideTimer = window.setTimeout(() => {
        setIsScrolling(false);
      }, SCROLL_HIDE_DELAY_MS);
    };

    containerEl.addEventListener('scroll', handleScroll);
    return (): void => {
      containerEl.removeEventListener('scroll', handleScroll);
      window.clearTimeout(hideTimer);
    };
  }, [containerEl]);

  return isScrolling;
};
